import { ref } from 'vue'
import { getClipboardText, dispatchCopyEventFrom } from '@/util/copypaste_helpers'

export function useCopyText() {
  const isTooltipOpen = ref(false)

  const copyText = async (
    text: string,
    event?: MouseEvent,
    options?: {
      autoHideTooltip?: boolean
      autoHideDelay?: number
      onCopied?: () => void
    }
  ) => {
    const textToCopy = getClipboardText(text)
    
    if (event) {
      const buttonElement = event.currentTarget as HTMLElement
      if (buttonElement) {
        dispatchCopyEventFrom(buttonElement, true, textToCopy)
      }
    }
    
    await navigator.clipboard.writeText(textToCopy)
    
    isTooltipOpen.value = true
    
    if (options?.autoHideTooltip) {
      setTimeout(() => {
        isTooltipOpen.value = false
      }, options.autoHideDelay || 2000)
    }
    
    if (options?.onCopied) {
      options.onCopied()
    }
  }

  return {
    isTooltipOpen,
    copyText
  }
}
